import { render, staticRenderFns } from "./BranchOffices.vue?vue&type=template&id=7b36f32c&scoped=true&"
import script from "./BranchOffices.vue?vue&type=script&lang=js&"
export * from "./BranchOffices.vue?vue&type=script&lang=js&"
import style0 from "./BranchOffices.vue?vue&type=style&index=0&id=7b36f32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36f32c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
